import React from "react";

export default function AttendanceDailyStatusSummary({
  dailyStats,
  filteredCount,
  isMobile,
  theme,
}) {
  return (
    <div className={`mb-8 ${isMobile ? "px-4 mt-6" : ""}`}>
      <div className="flex items-end justify-between mb-3 px-2">
        <h3 className="text-xl font-black text-gray-800">오늘의 출석 현황</h3>
        <div className="flex items-baseline gap-2">
          <span className={`text-4xl font-black ${theme.text} font-do-hyeon`}>
            {Math.round(((dailyStats.present + dailyStats.late) / (filteredCount || 1)) * 100)}%
          </span>
          <span className="text-sm font-bold text-gray-400">출석률</span>
        </div>
      </div>

      <div className="h-6 w-full bg-gray-100 rounded-full flex overflow-hidden shadow-inner border border-gray-200/50">
        <div style={{ width: `${(dailyStats.present / (filteredCount || 1)) * 100}%` }} className="h-full bg-emerald-500 hover:bg-emerald-400 transition-colors relative group">
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity text-[10px] font-bold text-white">출석 {dailyStats.present}</div>
        </div>
        <div style={{ width: `${(dailyStats.late / (filteredCount || 1)) * 100}%` }} className="h-full bg-amber-400 hover:bg-amber-300 transition-colors relative group">
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity text-[10px] font-bold text-white">지각 {dailyStats.late}</div>
        </div>
        <div style={{ width: `${(dailyStats.absent / (filteredCount || 1)) * 100}%` }} className="h-full bg-rose-500 hover:bg-rose-400 transition-colors relative group">
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity text-[10px] font-bold text-white">결석 {dailyStats.absent}</div>
        </div>
        <div style={{ width: `${(dailyStats.none / (filteredCount || 1)) * 100}%` }} className="h-full bg-gray-200 hover:bg-gray-300 transition-colors relative group">
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity text-[10px] font-bold text-gray-600">미처리 {dailyStats.none}</div>
        </div>
      </div>

      <div className="flex justify-end gap-4 mt-3 px-2">
        <div className="flex items-center gap-1.5">
          <div className="w-2.5 h-2.5 rounded-full bg-emerald-500"></div>
          <span className="text-xs font-bold text-gray-500">출석 <span className="text-gray-800">{dailyStats.present}</span></span>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="w-2.5 h-2.5 rounded-full bg-amber-400"></div>
          <span className="text-xs font-bold text-gray-500">지각 <span className="text-gray-800">{dailyStats.late}</span></span>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="w-2.5 h-2.5 rounded-full bg-rose-500"></div>
          <span className="text-xs font-bold text-gray-500">결석 <span className="text-gray-800">{dailyStats.absent}</span></span>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="w-2.5 h-2.5 rounded-full bg-gray-300"></div>
          <span className="text-xs font-bold text-gray-500">미처리 <span className="text-gray-800">{dailyStats.none}</span></span>
        </div>
      </div>
    </div>
  );
}
